/**
 * axios 请求方法封转
 */
import axios from 'axios';
import router from '../router/index';
import store from '../store'
import config from '../utils/config'
import {
    message
} from "ant-design-vue"

/**
 * axios 登录请求方法
 * @param：{string}     method          请求类型,必填
 * @param：{string}     url             请求地址,必填
 * @param：{string}     params          请求参数,必填
 * @param：{string}     variation       是否变异,非必填
 **/

//  请求前 =》 取消其他界面的请求
axios.interceptors.request.use(
        config => {
            if (config.method === "get") {
                config.data = { unused: 0 }; // 这个是关键点，加入这行就可以了,解决get,请求添加不上Content-Type
            }
            // config.headers.Authorization = localStorage.getItem('userInfo')
            config.cancelToken = new axios.CancelToken(function(cancel) {
                store.commit('pushToken', { cancelToken: cancel })
            })
            return config
        }
    )
    //  响应前
axios.interceptors.response.use((response) => {
    return Promise.resolve(response);
}, (error) => {
    if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
        return new Promise(() => {});
    } else {
        if (error.response.status == '401') {
            message.error("登录失效，请重新登录！");
            localStorage.clear()
            router.push({
                path: config.loginURL
            })
            return new Promise(() => {});
        }
        return Promise.reject(error);
    }
})

const loginRequest = (method, url, params, variation = "F") => {

    // variation用于判断返回的数据是正确的还是错误的(用与返回resolves 还是 reject)
    if (variation == "F") {
        return axios({
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
            },
            data: params
        }).then(res => res.data);
    } else {
        return axios({
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
            },
            params: params
        }).then(res => res.data);
    }

};

/**
 * axios 通用公用方法
 * @param：{string}     method          请求类型,必填
 * @param：{string}     url             请求地址,必填
 * @param：{string}     params          请求参数,必填
 * @param：{string}     variation       是否变异,非必填
 **/
const request = (method, url, params, responseType, variation = "F", contentType = "application/json") => {
    if (variation == "F") {
        // console.log(123)
        return axios({
                method: method,
                url: url,
                headers: {
                    'Content-Type': contentType,
                    'Authorization': localStorage.getItem("token") || '',
                    
                },
                data: params,
                responseType: responseType,
            }).then(res => res.data)
            .catch(function(err) {
                if (err.response.status === 401) {
                    // 401 说明 token 验证失败
                    // 可以直接跳转到登录页面，重新登录获取 token
                    message.error("登录失效，请重新登录！");
                    localStorage.clear()
                    router.push({
                        path: config.loginURL
                    })
                }
            });
    } else {
        return axios({
            method: method,
            url: url,
            headers: {
                'Authorization': localStorage.getItem("token") || '',
                'Content-Type': contentType
            },
            params: params,
        }).then(res => res.data).catch(function(err) {
            if (err.response.status === 401) {
                // 401 说明 token 验证失败
                // 可以直接跳转到登录页面，重新登录获取 token
                message.error("登录失效，请重新登录！");
                localStorage.clear()
                router.push({
                    path: config.loginURL
                })
            }
        });
    }
};

const request2 = (method, url, params, responseType, variation = "F", contentType = "application/json") => {
    if (variation == "F") {
        // console.log(123)
        return axios({
                method: method,
                url: url,
                headers: {
                    'Content-Type': contentType,
                    
                },
                data: params,
                responseType: responseType,
            }).then(res => res.data)
            .catch(function(err) {
                if (err.response.status === 401) {
                    // 401 说明 token 验证失败
                    // 可以直接跳转到登录页面，重新登录获取 token
                    message.error("登录失效，请重新登录！");
                    localStorage.clear()
                    router.push({
                        path: config.loginURL
                    })
                }
            });
    } else {
        return axios({
            method: method,
            url: url,
            headers: {
                'Content-Type': contentType
            },
            params: params,
        }).then(res => res.data).catch(function(err) {
            if (err.response.status === 401) {
                // 401 说明 token 验证失败
                // 可以直接跳转到登录页面，重新登录获取 token
                message.error("登录失效，请重新登录！");
                localStorage.clear()
                router.push({
                    path: config.loginURL
                })
            }
        });
    }
};

export {
    loginRequest,
    request,
    request2
}